import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { routeParams } from '../../../../../shared/shared.global-service';

@Injectable()
export class ServiceSettingsCommonStore extends ComponentStoreV2Factory {
    serviceId = computed(() => Number(routeParams.serviceId()));

    public services = computed(() => {
        return this.globalGlobalStore.organizationStore.allServices()
            .filter((service) => service.id !== this.serviceId())
            ;
    });

}
